import ApiClient from '@/helpers/api/api.helpers';

class Presence extends ApiClient {
  constructor() {
    super('app-setting/presence');
  }
}

export default new Presence();
